import React from 'react';
import { Link } from 'react-router-dom';

const events = [
  { id: 1, title: 'Introductiefeest Amsterdam', date: '15 Apr 2026', city: 'Amsterdam', desc: 'Grootste introductiefeest voor nieuwe studenten' },
  { id: 2, title: 'StudentenBorrel Rotterdam', date: '22 Apr 2026', city: 'Rotterdam', desc: 'Wekelijkse borrel met live DJ' },
  { id: 3, title: 'Career Mixer Utrecht', date: '28 Apr 2026', city: 'Utrecht', desc: 'Netwerkevenement met topbedrijven' },
  { id: 4, title: 'Study Skills Workshop', date: '5 Mei 2026', city: 'Online', desc: 'Leer effectief studeren met tips van oud-studenten' },
];

export default function EventsPage() {
  return (
    <div className="container mx-auto px-4 py-20">
      <h1 className="text-5xl font-bold text-center mb-12 text-gray-800">Evenementen</h1>
      <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
        {events.map(ev => (
          <div key={ev.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition">
            <img src={`https://picsum.photos/seed/event${ev.id}/400/200`} alt={ev.title} className="w-full h-48 object-cover" />
            <div className="p-6">
              <div className="text-sm text-blue-600 font-semibold mb-2">{ev.date} • {ev.city}</div>
              <h3 className="text-xl font-bold mb-3">{ev.title}</h3>
              <p className="text-gray-600 mb-4">{ev.desc}</p>
              <Link to={`/events/${ev.id}`} className="text-blue-600 font-semibold hover:text-blue-800">Bekijk details →</Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
